import axios from "axios";
import {
  CREATED_TRAVELER_PROFILE,
  IPerson,
  TravelerProfileProperties,
  UPDATED_TRAVELER_PROFILE,
} from "redmond";
import { isCorpTenant, replaceObjectValues } from "@capone/common";
import { ToggleActions } from "halifax";
import { config } from "../../../config";

import { passengersApiPrefix } from "../../paths";
import { trackEvent } from "../../analytics/trackEvent";
import { getCarLoyaltyProgramName } from "../../../../utils/loyalty";


const END_POINT: string = `${passengersApiPrefix}/update`;

export const updateUserPassenger = (
  body: IUpdateUserPassengerRequest
): Promise<IUpdateUserPassengerResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const {
        isNewTraveler,
        hideProfileAction,
        entryPoint,
        person,
        ...payload
      } = body;

      const cleanPersonPayload = replaceObjectValues(person, "", null);

      const res = await axios.put(
        END_POINT,
        { ...payload, person: cleanPersonPayload },
        {
          baseURL: config.baseURL,
        }
      );

      const responseBody: IUpdateUserPassengerResponse = res.data;
      resolve(responseBody);

      if (isCorpTenant(config.TENANT)) {
        const frequentFlyerProgramsAmount = Reflect.ownKeys(
          body.person.frequentFlyer
        ).length;
        const hotelLoyaltyProgramsAmount = Reflect.ownKeys(
          body.person.hotelLoyalty
        ).length;
        const carLoyaltyVendorCodes = Reflect.ownKeys(
          body.person.groundLoyalty ?? {}
        ) as string[];

        trackEvent({
          eventName: isNewTraveler
            ? CREATED_TRAVELER_PROFILE
            : UPDATED_TRAVELER_PROFILE,
          properties: {
            frequent_flyer_program_added: frequentFlyerProgramsAmount > 0,
            num_frequent_flyer_programs: frequentFlyerProgramsAmount,
            hotel_loyalty_program_added: hotelLoyaltyProgramsAmount > 0,
            num_hotel_loyalty_programs: hotelLoyaltyProgramsAmount,
            car_loyalty_program_added: isNewTraveler
              ? carLoyaltyVendorCodes.length > 0
              : carLoyaltyVendorCodes.length > (body.previousCarLoyaltyCount ?? 0),
            car_loyalty_programs_in_profile: carLoyaltyVendorCodes
              .map((vendorCode) => getCarLoyaltyProgramName(vendorCode))
              .filter((name): name is string => name !== undefined),
            source: body.source,
            private: hideProfileAction === ToggleActions.ON,
            entry_point: entryPoint,
          } satisfies TravelerProfileProperties,
        });
      }
    } catch (e) {
      reject(e);
    }
  });

export interface IUpdateUserPassengerRequest {
  person: IPerson;
  isNewTraveler?: boolean;
  previousCarLoyaltyCount?: number;
  source?: string;
  hideProfileAction?: ToggleActions;
  entryPoint?: string;
}

export interface IUpdateUserPassengerResponse {}
